import { render, staticRenderFns } from "./c-ajaxlist.vue?vue&type=template&id=d24851cc&scoped=true"
import script from "./c-ajaxlist.vue?vue&type=script&lang=js"
export * from "./c-ajaxlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24851cc",
  null
  
)

export default component.exports